import React__default from 'react';
import { getRenderLeaf } from '../../../../core/rendering/getRenderLeaf.mjs';
import { hasMark } from '../../../../core/utilities/nodes/marks/hasMark.mjs';
import { getLeafDeserializer } from '../../../../core/serialization/deserialize/utilities/getLeafDeserializer.mjs';
import { getHotkeyHandler } from '../../../../core/utilities/handlers/hotkeys/getHotkeyHandler.mjs';
import { getToggleMarkHotkey } from '../../../../core/utilities/handlers/hotkeys/getToggleMarkHotkey.mjs';

const Type = 'underline';
const hotkey = 'Ctrl+U';
const inlineStyles = {
  textDecoration: 'underline'
};
const UnderlinePlugin = options => ({
  type: Type,
  hotkey,
  renderLeaf: getRenderLeaf({
    type: Type,
    rootProps: {},
    component: Underline
  }),
  serialize: {
    leaf({
      children,
      leaf
    }) {
      if (hasMark(leaf, Type)) {
        return `<span style="text-decoration:${inlineStyles.textDecoration}">${children}</span>`;
      }
      return children;
    }
  },
  deserialize: {
    leaf: getLeafDeserializer({
      type: Type,
      rules: [{
        nodeNames: ['U']
      }, {
        nodeNames: ['SPAN'],
        style: ({
          textDecoration
        }) => textDecoration === null || textDecoration === void 0 ? void 0 : textDecoration.includes(inlineStyles.textDecoration)
      }]
    })
  },
  onKeyDown: options !== null && options !== void 0 && options.onHotkey ? getHotkeyHandler(hotkey, options.onHotkey) : getToggleMarkHotkey({
    type: Type,
    hotkey
  })
});
function Underline({
  attributes,
  children
}) {
  return /*#__PURE__*/React__default.createElement("u", attributes, children);
}

export { Type, UnderlinePlugin, hotkey };
